{ Jadelet, Modal } from @danielx/dui

{ midiKeySignatureName } from ../lib/util.civet

// TODO: unhide once key signature support is improved
Template := Jadelet.exec """
  aside.signature-picker(class=@hiddenUnlessPurchased)
    label Key
    button(@click) @keyName
"""

ButtonTemplate := Jadelet.exec """
  button(@click class=@active) @text
"""

PickerTemplate := Jadelet.exec """
  section.key-signature
    h2 Key Signature
    button.close(click=@close) X
    div @majorKeys
    div @minorKeys
"""

export SignaturePicker := (player: Player) ->

  showAdvancedPicker := ->
    Modal.show PickerTemplate
      close: ->
        Modal.hide()

      majorKeys: ->
        [-7..7].map (key) ->
          scale := 0
          ButtonTemplate
            active: ->
              {key:currentKey, scale:currentScale} := player.keySignature()
              "active" if key is currentKey and scale is currentScale
            click: ->
              player.keySignature key, scale
            text: midiKeySignatureName key

      minorKeys: ->
        [-7..7].map (key) ->
          scale := 1

          ButtonTemplate
            active: ->
              {key:currentKey, scale:currentScale} := player.keySignature()
              "active" if key is currentKey and scale is currentScale
            click: ->
              player.keySignature key, scale
            text: midiKeySignatureName key, scale

  self :=
    keyName: ->
      {key, scale} := player.keySignature()

      midiKeySignatureName key, scale

    click: showAdvancedPicker
    hiddenUnlessPurchased: player.hiddenUnlessPurchased

    element: null as! HTMLElement

  self.element = Template self

  return self

export default SignaturePicker
